module.exports = __webpack_public_path__ + "static/media/amex_logo.81eef79b.jpeg";